import {useContext, useEffect, useState} from 'react';
import {message} from 'antd';
export type RequestErrorHandler = (error: Error) => any;
import {AxiosRequestConfig} from 'axios';
import useAuth from '../utils/AuthContext';
import {useAxios} from '../utils/AxiosProvider';

export default function usePost<Params, Response>(
  api: string,
  props: {
    defaultParams?: Partial<Params>;
  },
) {
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const axios = useAxios();
  async function request(params: Params, axiosConfig?: AxiosRequestConfig): Promise<Response> {
    try {
      setLoading(true);
      const config: AxiosRequestConfig = {...axiosConfig};
      if (auth.token) {
        config.headers = {
          'Application-Token': auth.token,
        };
      }

      const data = {
        ...props.defaultParams,
        ...params,
      };
      const res = await axios.instance.post<Response>(api, config.onUploadProgress ? params : data, config);
      setLoading(false);
      return Promise.resolve(res.data);
    } catch (e) {
      setLoading(false);
      return Promise.reject(e);
    }
  }

  return {
    loading,
    request,
  };
}
